
export const getters = {
    systemcargosRows: state => state.cargos,
    systemCargos: state => state.cargoentries,
    Cargo: state => state.systemCargo,
    systemFileCargos: state => state.fileopeningcargos,
    Cargofile: state => state.systemCargofile
}
export default getters


// WEBPACK FOOTER //
// ./src/vuex/modules/cargoentries/getters.js